import Component from '../core/Component'
import { enableScrolling, disableScrolling } from '../services/Scroll'
import support from '../utils/BrowserSupport'
import keycode from 'keycode'
import throttle from 'lodash/throttle'
import debounce from 'lodash/debounce'
import $ from 'jquery'
import elementToObject from '../utils/elementToObject'
import SearchResult from './SearchResult'
import SearchNoResult from './SearchNoResult'

export const STATES = {
    VISIBLE: 'is-visible',
    ACTIVE: 'is-active',
    NO_RESULT: 'has-no-result',
}

export default class SearchLayer extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            background: null,
            closeButton: null,
            input: null,
            form: null,
            results: [],
            content: null,
            card: null,
            noResult: null,
            term: null,
        }

        this.handleKeyDown = ::this.handleKeyDown
        this.request = null
        this.results = []
    }

    prepare() {
        this.element.addEventListener(support.transitionEnd, () => {
            if (!this.is(STATES.ACTIVE)) {
                this.element.classList.remove(STATES.VISIBLE)
            }
        })
        this.element.addEventListener('click', ::this.handleClick)

        this.ref.background.addEventListener('click', ::this.handleCloseClick)
        this.ref.closeButton.addEventListener('click', ::this.handleCloseClick)

        this.ref.input.addEventListener('keyup', throttle(::this.handleKeyUp, 200))
        this.ref.input.addEventListener('keyup', debounce(::this.handleDebouncedKeyUp, 1500))
        this.ref.form.addEventListener('submit', throttle(::this.handleSubmit, 200))

        this.results = this.ref.results
            .map((element) => {
                const result = new SearchResult(element)
                result.prepare()
                return result
            })
            .reduce((acc, result) => {
                acc[result.type] = result
                return acc
            }, {})

        this.noResult = new SearchNoResult(this.ref.noResult)
        this.noResult.prepare()
    }

    destroy() {
        document.removeEventListener('keydown', this.handleKeyDown)
        this.results.forEach((result) => result.destroy())
        this.noResult.destroy()
    }

    handleClick(event) {
        if (event.target.closest('a')) {
            this.close()
        }
    }

    handleCloseClick(event) {
        event.preventDefault()
        this.close()
    }

    handleSubmit(event) {
        event.preventDefault()
        this.refresh()
    }

    handleKeyDown(event) {
        if (keycode(event.keyCode) === 'esc') {
            this.close()
        }
    }

    handleKeyUp() {
        this.refresh()
    }

    handleDebouncedKeyUp() {
        let data = elementToObject(this.ref.form)
        data.action = 'log'
        $.ajax({
            url: this.ref.form.dataset.url,
            data,
        })
    }

    handleResponse(response, value = '') {
        this.showResults()

        if (typeof response !== 'object') {
            this.element.classList.add(STATES.NO_RESULT)
            return
        }

        if(response.stores.length !== 0 || response.fulltext.length !== 0) {
            this.ref.results.forEach(result => {
                result.style.display = "block"
            })
        }

        if(response.stores.length === 0) {
            this.ref.results.forEach(result => {
                if(result.classList.contains('search-Results-block--stores')) {
                    result.style.display = "none"
                }
            })
        }

        if(response.fulltext.length === 0) {
            this.ref.results.forEach(result => {
                if(result.classList.contains('search-Results-block--fulltext')) {
                    result.style.display = "none"
                }
            })
        }

        if (response.term) {
            response.term = [{ term: response.term }]

            this.ref.term.style.display = 'block'
            this.ref.term.querySelector('.Text').innerHTML = response.term[0].term

            if (response.term !== null && this.ref.card) {
                if (inputValue && response.fulltext.length == 0) {
                    this.ref.card.classList.add(STATES.ACTIVE)
                    this.ref.card.parentElement.classList.add(STATES.ACTIVE)

                    const resultsEl = this.ref.results[0]
                    if (resultsEl.classList.contains(STATES.ACTIVE)) {
                        this.ref.results[0].classList.remove(STATES.ACTIVE)
                    }
                }
            }
        } else {
            this.ref.term.style.display = 'none'
        }

        if (response.important == 1) {
            this.element.classList.add('is-important')
        } else {
            this.element.classList.remove('is-important')
        }

        // check if has some items
        const length = Object.keys(response)
            .filter((key) => Array.isArray(response[key]))
            .filter((key) => response[key].length > 0).length

        this.showResults()

        // show parking card
        const inputValue = this.ref.input.value
        if (response.term !== null && this.ref.card) {
            if (inputValue && response.fulltext.length == 0) {
                this.ref.card.classList.add(STATES.ACTIVE)
                hideResults()
            }
        }
        if (response.term === null) {
            if (this.ref.card) {
                this.ref.card.classList.remove(STATES.ACTIVE)
            }
        }

        if (!(length > 0)) {
            this.noResult.render(value)
            this.element.classList.add(STATES.NO_RESULT)
            if (this.ref.card) {
                this.ref.card.classList.remove(STATES.ACTIVE)
            }
            return
        } else {
            this.element.classList.remove(STATES.NO_RESULT)
        }

        // reformat for svg vs png image
        if (response.stores) {
            response.stores = response.stores.map((store) => {
                let image = ''
                if (store.svg) {
                    image = `<img src="${store.svg}">`
                } else {
                    image = `<img src="${store.image}" srcset="${store.imageRetina} 2x">`
                }

                return {
                    ...store,
                    image,
                }
            })
        }

        Object.keys(response)
            .filter((key) => this.results[key])
            .forEach((key) => this.results[key].render(response[key]))
    }

    refresh() {
        if (this.request) {
            this.request.abort()
        }

        const value = this.ref.input.value.trim()

        if (value !== '') {
            this.request = $.ajax({
                url: this.ref.form.dataset.url,
                data: elementToObject(this.ref.form),
            })

            this.request.then((response) => this.handleResponse(response, value))
        } else {
            this.hideResults()
        }
    }

    hideResults() {
        this.ref.content.classList.remove(STATES.ACTIVE)
    }

    showResults() {
        this.ref.content.classList.add(STATES.ACTIVE)
    }

    open() {
        disableScrolling()
        this.element.classList.add(STATES.VISIBLE)
        this.element.offsetWidth
        this.element.classList.add(STATES.ACTIVE)
        document.addEventListener('keydown', this.handleKeyDown)

        if (this.ref.input) {
            this.ref.input.focus()
        }
    }

    close() {
        enableScrolling()
        this.element.classList.remove(STATES.ACTIVE)
        document.removeEventListener('keydown', this.handleKeyDown)
        this.hideResults()
        this.element.classList.remove(STATES.NO_RESULT)
    }
}
